import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'audio',
    'currentTime',
  ];

  static values = {
    srcUrl: String,
    durationInSeconds: {
      type: Number,
      default: 0,
    },
    isPlaying: {
      type: Boolean,
      default: false,
    },
  };

  connect() {
    this.audioTarget.src = this.srcUrlValue;
    this.setupEventListeners();
    this.displayDuration();
    this.interval = setInterval(this.whilePlaying.bind(this), 100);
  }

  disconnect() {
    clearInterval(this.interval);
  }

  setupEventListeners() {
    this.audioTarget.addEventListener('pause', this.handleAudioPaused.bind(this));
    this.audioTarget.addEventListener('play', this.handleAudioPlay.bind(this));
    this.audioTarget.addEventListener('ended', this.handleAudioEnded.bind(this));
  }

  handleAudioEnded() {
    this.isPlayingValue = false;
    this.displayDuration();
  }

  handleAudioPaused() {
    this.isPlayingValue = false;
  }

  handleAudioPlay() {
    this.isPlayingValue = true;
  }

  handleClick(event) {
    const target = event.target
    const dimensions = target.getBoundingClientRect();
    const offsetX = event.clientX - dimensions.left;
    const offsetPercentage = Math.floor(offsetX / dimensions.width * 100);
    const targetTime = Math.floor(offsetPercentage / 100 * this.getDurationInSeconds());

    this.audioTarget.currentTime = targetTime;
    console.log('setting currentTime', targetTime);
    this.updateCurrentTimeDisplayAndProgress();
  }

  isPlayingValueChanged() {
    this.element.classList.toggle('is-playing', this.isPlayingValue);
  }

  togglePlay() {
    if(this.isPlayingValue) {
      this.audioTarget.pause();
    } else {
      this.audioTarget.play();
    }
  }

  whilePlaying() {
    if(this.isPlayingValue) {
      this.updateCurrentTimeDisplayAndProgress();
    }
  }

  updateCurrentTimeDisplayAndProgress() {
    const playbackTimeInSeconds = this.audioTarget.currentTime;
    this.currentTimeTarget.textContent = this.calculateTime(Math.floor(playbackTimeInSeconds));
    const progressPercentage = Math.ceil(playbackTimeInSeconds / this.getDurationInSeconds() * 100);
    this.setAudioPlayerProperty('current-progress', `${progressPercentage}%`);
  }

  calculateTime(secs) {
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    const returnedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const returnedSeconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${returnedMinutes}:${returnedSeconds}`;
  }

  displayDuration() {
    this.currentTimeTarget.textContent = this.calculateTime(Math.floor(this.getDurationInSeconds()));
  }

  getDurationInSeconds() {
    return this.audioTarget.duration || this.durationInSecondsValue;
  }

  setAudioPlayerProperty(propertyName, value) {
    this.element.style.setProperty(`--${propertyName}`, value);
  }
}

